<template>
  <div
    v-if="authStore.isImpersonating"
    class="impersonate-banner fixed top-0 left-0 right-0 z-[100] bg-amber-500 text-white px-4 py-2 flex items-center justify-center gap-4 shadow-md"
  >
    <i class="pi pi-exclamation-triangle text-lg"></i>
    <span class="font-medium text-sm">
      {{ t('impersonate.banner.acting_as', { email: authStore.user?.email || '' }) }}
    </span>
    <Button
      :label="t('impersonate.banner.stop')"
      icon="pi pi-sign-out"
      size="small"
      severity="contrast"
      outlined
      :loading="stopping"
      @click="handleStop"
      class="!text-white !border-white hover:!bg-white/20"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import Button from 'primevue/button'

const { t } = useI18n({ useScope: 'global' })
const authStore = useAuthStore()
const router = useRouter()
const stopping = ref(false)

const handleStop = async () => {
  stopping.value = true
  try {
    await authStore.stopImpersonation()
    router.push('/')
  } catch (error) {
    console.error('Failed to stop impersonation:', error)
  } finally {
    stopping.value = false
  }
}
</script>

<style scoped>
.impersonate-banner {
  font-family: inherit;
}
</style>
